import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getCongenereEligibility} from '../../services/getCongenereEligibility';
import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';
import {wasDrawerDismissedToday} from 'presentation/utils';

export const useGetCongenereEligibilityQuery = () => {
	const {congenereDrawerDismissedDate} = useCongenereEligibilityStore();

	const enabled = !wasDrawerDismissedToday(congenereDrawerDismissedDate);

	return useQuery({
		queryKey: [QUERY_KEYS.CONGENERE_ELIGIBILITY],
		queryFn: ({signal}) => getCongenereEligibility(signal),
		retry: 1,
		enabled,
	});
};
